import { Button, Dropdown } from '@drip/drip-design';
import React, { useState, useEffect } from 'react';
import { FilterFilledBase } from '@drip/drip-design-icons';
import MultipleSelectPanel from '@/components/multiple-select-panel';
import './index.less';

function TableColumnCateOption(props) {
  const { options, onChange, closeDropdown, value } = props;
  const [localValue, setLocalValue] = useState([]);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  return (
    <div className="Table-Column-Cate-Option">
      <MultipleSelectPanel
        options={options}
        value={localValue}
        onChange={(value, selectedOptions) => {
          setLocalValue(value);
        }}
        showResultPanel={false}
        selectPanel={{ panelNameList: ['一级类目', '二级类目', '三级类目'] }}
        fieldNames={{ label: 'name', value: 'key', children: 'children' }}
      />
      <div className="Table-Column-Cate-Option-footer">
        <a onClick={() => setLocalValue([])}>重置</a>
        <Button
          type="primary"
          size="small"
          onClick={() => {
            onChange(localValue);
            closeDropdown();
          }}
        >
          确定
        </Button>
      </div>
    </div>
  );
}

function RenderOptions(props) {
  const [visible, setVisible] = useState(false);
  return (
    <Dropdown
      trigger={['click']}
      onVisibleChange={(e) => setVisible(e)}
      visible={visible}
      overlay={(e) => <TableColumnCateOption closeDropdown={(e) => setVisible(false)} {...props} />}
    >
      <FilterFilledBase className="cates-filter-icon" />
    </Dropdown>
  );
}

export default RenderOptions;
